module.exports = __webpack_public_path__ + "static/media/保腎護心網layout物件_55.0ab42f08.png";